<template lang="pug">
.form-charge
  h2 {{contract_id?'':'空房'}}水电充值

  .ui.two.columns.stackable.grid.form
    .column
      template(v-if='!$config.logic.manual_meter')
        .actions
          .ui.button.orange(@click='set({electricity: 100})') 电100度
          .ui.button.yellow(@click='set({electricity: 70})') 电70度
          .ui.button.yellow(@click='set({electricity: 50})') 电50度
          .ui.button.blue(@click='set({water: 16})') 冷水16吨
          .ui.button.themed(@click='set({kitchen: 50})') 厨房50度
          .ui.button(@click='set({water: 0, hot_water: 0, electricity:0, kitchen: 0})') 重置

        br
        .ui.four.fields
          .ui.field(v-for='utility in form.utilities')
            label {{$formatters.utility_label(utility.type)}} / {{$formatters.utility_unit(utility.type)}}
            compare-input(v-model='utility.quantity', :min='0', :allow-dot='false')

      .ui.two.fields
        .ui.field
          label 支付方式
          payment-method-select(v-model='form.payment_method')

        .ui.field
          label 备注
          el-input(v-model='form.note')

      .ui.two.fields
        .ui.field
          label 厨房开户费用
          compare-input(v-model='form.kitchen_open_fee', :min='0', :controls='false')

        .ui.field
          label 补卡费用
          compare-input(v-model='form.card_replenish_fee', :min='0', :controls='false')

    .column
      receipts.ui.segment(v-show='receipts && receipts.length', :receipts='receipts')

    .ui.field.actions
      template(v-if='$native.supported && !$config.logic.manual_meter')
        .ui.button.themed.icon.labeled(@click='finish(true)', :class='{disabled:!submitable && !auto_chargable}')
          i.icon.rocket
          | 自动充值
        .ui.button.olive.icon.labeled(@click='finish(false)', :class='{disabled:!submitable}')
          i.icon.checkmark
          | 手动充值
      template(v-else)
        .ui.button.themed.icon.labeled(@click='finish()', :class='{disabled:!submitable}')
          i.icon.checkmark
          | 完成充值
      .ui.button(@click='cancel') 取消

  el-dialog(title='自动充值中', :visible.sync='dialog_charging', size='tiny', :close-on-click-modal='false')
    span 请插入水电卡并等待充值过程完成。
    span.dialog-footer(slot='footer')
      el-button(@click='native_charge_cancel()') 取消
      el-button(type='primary', @click='native_charge_confirm()') 完成
</template>

<script>
import { MakeForm } from '../../utils'
import { AutoTable } from '../auto'
import { Receipts, PaymentMethodSelect, CompareInput } from '../basic'

export default {
  name: 'form-charge',
  props: ['no', 'contract_id'],
  components: {
    AutoTable,
    Receipts,
    PaymentMethodSelect,
    CompareInput,
  },
  data() {
    return {
      form: {
        utilities: [],
        note: '',
        payment_method: 'cash',
        kitchen_open_fee: 0,
        card_replenish_fee: 0,
      },
      dialog_charging: false,
    }
  },
  computed: {
    room() {
      return this.$store.getters.room(this.no)
    },
    contract() {
      if (this.contract_id)
        return this.$store.getters.contract(this.contract_id)
      return null
    },
    customers() {
      if (this.contract)
        return this.$store.getters.customers_filter(this.contract._customers)
      return []
    },
    submitable() {
      for (const utility of this.form.utilities) {
        if (utility.quantity > 0)
          return true
      }
      if (this.form.kitchen_open_fee > 0 || this.form.card_replenish_fee > 0)
        return true
      return false
    },
    auto_chargable() {
      if (!this.submitable)
        return false
      for (const utility of this.form.utilities) {
        if (utility.quantity > 0)
          return true
      }
      return false
    },
    receipts() {
      const receipts = []

      // Utilities Refund
      for (const utility of this.form.utilities) {
        if (utility.quantity) {
          receipts.push({
            name: this.$formatters.utility_label(utility.type),
            unit: this.$formatters.utility_unit(utility.type),
            unit_price: utility.unit_price,
            quantity: utility.quantity,
          })
        }
      }

      if (this.form.kitchen_open_fee) {
        receipts.push({
          name: '厨房开户费用',
          price: this.form.kitchen_open_fee,
        })
      }

      if (this.form.card_replenish_fee) {
        receipts.push({
          name: '补卡费用',
          price: this.form.card_replenish_fee,
        })
      }

      return receipts
    },

    electricity() { return this.quantity_of('electricity') },
    water() { return this.quantity_of('water') },
    hot_water() { return this.quantity_of('hot_water') },
    kitchen() { return this.quantity_of('kitchen') },
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.form.utilities = []
      for (const utility of this.room.utilities) {
        this.form.utilities.push({
          type: utility.type,
          quantity: 0,
          unit_price: this.$formatters.utility_price(utility.type) || 0,
          note: '',
        })
      }
      if (!this.contract_id)
        this.form.note = '空房水电充值'
    },
    print_charge() {
      this.$templater.request('charge', {
        room: this.room,
        contract: this.contract,
        utilities: this.form.utilities,
        note: this.form.note,
        payment_method: this.form.payment_method,
        customers: this.customers,
        kitchen_open_fee: this.form.kitchen_open_fee,
        card_replenish_fee: this.form.card_replenish_fee,
        $methods: this.$store.state.summary.payment_methods,
      })
    },
    quantity_of(type) {
      const util = this.form.utilities.filter(u => u.type === type)[0] || {}
      return util.quantity || 0
    },
    set_of(type, value) {
      const util = this.form.utilities.filter(u => u.type === type)[0] || {}
      util.quantity = value
    },
    set({ electricity, water, hot_water, kitchen }) {
      if (electricity !== undefined)
        this.set_of('electricity', electricity)
      if (water !== undefined)
        this.set_of('water', water)
      if (hot_water !== undefined)
        this.set_of('hot_water', hot_water)
      if (kitchen !== undefined)
        this.set_of('kitchen', kitchen)
    },
    native_charge() {
      this.dialog_charging = true
      this.$native.invoke(`autoit utilities charge ${this.electricity} ${this.water} ${this.hot_water}`, (response) => {
        if (response && response.text === '$success')
          this.native_charge_confirm()
        else {
          this.native_charge_cancel(response.replace('$error', '').trim())
          console.log(`Charge canceled ${(response || {}).text}`)
        }
      })
    },
    native_charge_kitchen() {
      this.dialog_charging = true
      this.$native.invoke(`autoit kitchen charge ${this.kitchen}`, (response) => {
        if (response && response.text === '$success')
          this.native_charge_confirm()
        else {
          this.native_charge_cancel(response.replace('$error', '').trim())
          console.log(`Charge canceled ${(response || {}).text}`)
        }
      })
    },
    native_charge_confirm() {
      this.dialog_charging = false
      this.sumbit_form(false) // False to disable confirm dialog
    },
    native_charge_cancel(reason) {
      this.dialog_charging = false
      let message = '操作终止，单据未提交。'
      if (reason === 'timeout')
        message = `等待超时，${message}`
      this.$message({ message, type: 'warning' })
    },
    finish(auto) {
      if (this.submitable) {
        if (auto && this.$native.supported) {
          if (this.kitchen && (this.electricity || this.water || this.hot_water))
            this.$alert('不支持同时充值水电与厨房电，请核对信息后继续', '操作终止', { type: 'warning' })
          else if (this.kitchen)
            this.native_charge_kitchen()
          else
            this.native_charge()
        } else
          this.sumbit_form()
      }
    },
    sumbit_form: MakeForm({
      type: 'post',
      url: 'charges',
      confirm: (confirm) => (confirm === false ? null : '确定进行充值？'),
      payload() {
        return {
          _room: this.room._id,
          _contract: this.contract ? this.contract._id : null,
          ...this.form,
        }
      },
      $afterSuccess() {
        this.print_charge()
        this.$router.back()
      },
    }),
    cancel() {
      this.$router.back()
    },
  },
}
</script>



// WEBPACK FOOTER //
// FormCharge.vue?10d51284